import { render } from "./DataTableTemplates.vue?vue&type=template&id=3d47588a&scoped=true"
import script from "./DataTableTemplates.vue?vue&type=script&lang=js"
export * from "./DataTableTemplates.vue?vue&type=script&lang=js"

import "./DataTableTemplates.vue?vue&type=style&index=0&id=3d47588a&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\ProtectionGuruVue\\client-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d47588a"]])

export default __exports__